export const NewsArticlesList = [
    {
        id:1,
        title:"News Articles",
        folderTitle:"/images/newsarticles/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","5.jpg","7.jpg","8.jpg","9.jpg","10.jpg","11.jpg"]
    },
     

]